// quotation-preview Content.js
import React from "react";
import { View, Text } from "@react-pdf/renderer";
import { styles } from "../styles";

const formatNumber = (num) => {
  return parseFloat(num || 0).toLocaleString("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const Content = ({ quotationData, startIndex = 0 }) => {
  return (
    <View style={styles.itemsTable}>
      <View style={styles.tableRow}>
        <Text style={styles.tableColNo}>No.</Text>
        <Text style={styles.tableColDesc}>Description</Text>
        <Text style={styles.tableColUnit}>Units</Text>
        <Text style={styles.tableCol}>Unit Price</Text>
        <Text style={styles.tableCol}>Amount</Text>
      </View>
      {quotationData.items.map((item, index) => (
        <View
          style={
            index === quotationData.items.length - 1
              ? styles.lastTableRow
              : styles.tableRow
          }
          key={index}
        >
          <Text style={styles.tableColNo}>{startIndex + index + 1}</Text>
          <Text style={styles.tableColDesc}>{item.description}</Text>
          <Text style={styles.tableColUnit}>{item.unit}</Text>
          <Text style={styles.tableCol}>{formatNumber(item.unitPrice)}</Text>
          <Text style={styles.tableCol}>{formatNumber(item.unit * item.unitPrice)}</Text>
        </View>
      ))}
    </View>
  );
};

export default Content;
